<template>
  <span class="st-radio">
    <input
      type="radio"
      :id="id"
      :aria-label="ariaLabel"
      :name="name"
      :value="value"
      :required="required"
      :disabled="disabled"
      @change="onChange"
      :checked="state"
      :tabindex="tabindex"
    />
    <label :for="id">
      <slot name="input-box">
        <span class="input-box">
          <span class="input-box-circle"></span>
        </span>
      </slot>
      <slot>default text</slot>
    </label>
  </span>
</template>

<script>
export default {
  name: "st-radio",
  model: {
    prop: "modelValue",
    event: "input",
  },
  props: {
    id: {
      type: String,
    },
    name: {
      type: String,
      default: null,
    },
    value: {
      default: "",
    },
    modelValue: {
      default: undefined,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tabindex: {
      type: String,
      default: "0",
    },
    ariaLabel: {
      type: String,
      default: "",
    },
    model: {},
  },
  computed: {
    classList: function() {
      return ["st-radio"];
    },
    state: function() {
      if (this.modelValue === undefined) {
        return this.checked;
      }
      return this.modelValue === this.value;
    },
  },
  methods: {
    onChange: function() {
      this.toggle();
    },
    toggle: function() {
      this.$emit("input", this.state ? "" : this.value);
    },
  },
  watch: {
    checked: function(newValue) {
      if (newValue !== this.state) {
        this.toggle();
      }
    },
  },
  mounted: function() {
    if (this.checked && !this.state) {
      this.toggle();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";

.st-radio {
  display: inline;
  > input {
    opacity: 0;
    position: absolute;
    + label > .input-box {
      display: inline-block;
      border: solid 0.125em #6e6054;
      border-radius: 50%;
      margin: 0;
      padding: 0;
      width: 1.25em;
      height: 1.25em;
      background: #fff;
      overflow: hidden;
      vertical-align: -12%;
      margin-right: rem-calc(4);
      user-select: none;
      > .input-box-circle {
        display: block;
        margin: 50%;
        width: 0%;
        height: 0%;
        background: #6e6054;
        border-radius: 50%;
        opacity: 0;
      }
    }
    &:checked + label > .input-box {
      border: solid 0.125em #6e6054;
    }
    &:checked + label > .input-box > .input-box-circle {
      opacity: 1;
      margin: 10%;
      width: 80%;
      height: 80%;
    }
    // Will change the em values when going through
    // the components and making them BEM compatible,
    // fixing colors etc. TODO for sharedlibrary.
    &:focus + label > .input-box,
    &:focus-visible + label > .input-box {
      opacity: 1;
      box-shadow: 0 0 0 0.125em $vit, 0 0 0 0.25em $varm-grå;
      outline: 0;
    }
    &:focus:not(:focus-visible) + label > .input-box {
      box-shadow: none;
    }

    &:disabled + label {
      opacity: 0.7;
    }
  }

  label {
    display: flex;
    flex-wrap: wrap;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.44;
    letter-spacing: normal;
    color: #4d4845;
    font-family: $source-sans-pro;
  }
}
</style>
